module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am500-db2aecf84db9b5facb425ab97b2df5ea.jpg";